import React,{useState,useEffect} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import {TextAreaInput1, TextInput} from '../../components/input';
import {BiErrorCircle,BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { toast } from 'react-hot-toast';
import SettingsMenu from '../staticscreens/SettingsMenu';
import GoBack from '../../components/back/GoBack';
import {Select} from 'antd'
import Uploader from '../../components/Uploader';
import { UploadUserFile } from '../../services/AuthServices';
import { CreateTeacherService, GetTeacherDetailService, UpdateTeacherService } from '../../services/class_booking/TeacherServices';
import { GetBookingSlotService } from '../../services/class_booking/bookingSlotServices';
import { GetBatchesSlotService } from '../../services/class_booking/batchesSlotServices';
import { GetFileStandardService } from '../../services/admin/FileStandardServices';

function TeacherCE() {

  const navigate = useNavigate()  
  const location = useLocation()
  const {state} = useLocation()

  const [data,setdata] = useState({
    name:'',
    designation:'',
    employee_id:'',
    email:'',
    phone:'',
    password:'',
    profile_photo:'',
    is_active:false,
    is_verified:false,
    app_access:false,
    show_in_feedback:true,
    expertise:'',
    booking_slots:[],
    batches_slots:[],
    class:'',
    type:'',
    sort:'',
    mode:''
  })

  const teacherTypeArr = [{label:'Counsellor',value:'Counsellor'},{label:'Batch',value:'Batch'}]
  const modesArr = [{label:'Online',value:'online'},{label:'Offline',value:'offline'}]
  

  const [booking_slots,setbooking_slots] = useState([])
  const [batches_slots,setbatches_slots] = useState([])
  const [filter_standard,setfilter_standard] = useState([])

  useEffect(()=>{
    if(location?.pathname?.split('/')[location?.pathname?.split('/').length - 1] === 'edit'){
      getdata()
    }
    getbooking_slots()
    getbatches_slots()
    getfilter_standard()
  },[])

  const [error,seterror] = useState({
    name:'',
    designation:'',
    employee_id:'',
    email:'',
    phone:'',
    password:'',
    profile_photo:'',
    is_active:false,
    is_verified:false,
    app_access:false,
    expertise:'',
    booking_slots:'',
    batches_slots:'',
    class:'',
    type:'',
    sort:''
  })

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
};

  async function getbooking_slots() {
    const response = await GetBookingSlotService();
    let arr = [];

    response?.data?.datas?.forEach((d) => {
      arr.push({
        label: `${formatTo12Hour(d?.start_time)} - ${formatTo12Hour(d?.end_time)}`,
        value: d?._id,
      });
    });

    setbooking_slots(arr);
  }

  async function getbatches_slots() {
    const response = await GetBatchesSlotService();
    let arr = [];

    response?.data?.datas?.forEach((d) => {
      arr.push({
        label: `${formatTo12Hour(d?.start_time)} - ${formatTo12Hour(d?.end_time)}`,
        value: d?._id,
      });
    });
    setbatches_slots(arr);
  }

  async function getfilter_standard() {
    const response = await GetFileStandardService();
    let arr = [];
    response?.data?.datas?.forEach((d) => {
      arr.push({
        label: d?.label,
        value: d?._id,
      });
    });
    setfilter_standard(arr);
  }


  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  
  async function getdata(){
    const response = await GetTeacherDetailService(state)
    let d = response?.data?.datas[0]
    

    setdata({...data,
      name:d?.name,
      designation:d?.designation,
      email:d?.email,
      phone:d?.phone,
      employee_id:d?.employee_id,
      is_active:d?.is_active,
      is_verified:d?.is_verified,
      show_in_feedback:d?.show_in_feedback === undefined ? true : d?.show_in_feedback,
      is_partially_verified:d?.is_partially_verified,
      sent_for_review:d?.sent_for_review,
      app_access:d?.app_access,
      profile_photo:d?.profile_photo,
      expertise:d?.expertise,
      booking_slots:d?.booking_slots === undefined ? [] : d?.booking_slots?.map((d1)=>({label: `${formatTo12Hour(d1?.start_time)} - ${formatTo12Hour(d1?.end_time)}`,
      value: d1?._id})),
      batches_slots:d?.batches_slots === undefined ? [] : d?.batches_slots?.map((d1)=>({label: `${formatTo12Hour(d1?.start_time)} - ${formatTo12Hour(d1?.end_time)}`,
      value: d1?._id})),
      sort:d?.sort,
      type:{label:d?.type,value:d?.type},
      class:{label:d?.class?.label,value:d?.class?._id},
      mode:modesArr?.find((m)=>m?.value === d?.mode)
    })
  }

  async function submitdata(){
    if(!data.name){
        seterror({...error,name:'This Field is required*'})
    }else if(!data.employee_id){
        seterror({...error,employee_id:'This Field is required*'})
    }else if(!data.phone){
        seterror({...error,phone:'This Field is required*'})
    }else if(data.phone.length !== 10){
        seterror({...error,phone:'Enter a valid 10 digit mobile no*'})
    }else if(!data.sort){
        seterror({...error,sort:'This Field is required*'})
    }else if(!data.type){
        seterror({...error,type:'This Field is required*'})
    }else if(!data.class){
        seterror({...error,class:'This Field is required*'})
    }else if(!data.mode){
        seterror({...error,mode:'This Field is required*'})
    }else{
         

        
        let send_data = {...data}
        send_data['booking_slots'] = data?.booking_slots?.map((e)=>e?.value)
        send_data['batches_slots'] = data?.batches_slots?.map((e)=>e?.value)
        send_data['type'] = data?.type?.value
        send_data['class'] = data?.class?.value
        send_data['mode'] = data?.mode?.value

      
        if(location.pathname.split('/')[location.pathname.split('/').length - 1] === 'create'){
            const response = await CreateTeacherService(send_data)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 201){
                toast.success("Teacher Onboarded Successfully")
                resetform()
            }
        }else{
            const response = await UpdateTeacherService(send_data,state)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 200){
                toast.success("Teacher Updated Successfully")
                resetform()
                navigate(-1)
            }
        }
        
    }
  }

  function resetform(){
    setdata({
        name:'',
        designation:'',
        employee_id:'',
        email:'',
        phone:'',
        password:'',
        profile_photo:'',
        is_active:false,
        is_verified:false,
        app_access:false,
        show_in_feedback:true,
        expertise:'',
        booking_slots:[],
        batches_slots:[],
        class:'',
        type:'',
        sort:'',
        mode:''
      })
    seterror({
        name:'',
        designation:'',
        employee_id:'',
        email:'',
        phone:'',
        password:'',
        profile_photo:'',
        is_active:false,
        is_verified:false,
        app_access:false,
        expertise:'',
        booking_slots:'',
        batches_slots:'',
        class:'',
        type:'',
        sort:'',
        mode:''
      })
  }

  async function UploadFile(e,name){
     const fd = new FormData()
      fd.append('file',e)
      const response = await UploadUserFile(fd)
      setdata({...data,profile_photo:response?.data?.data})

    }


    console.log("data",data)

async function handleSelect(e,e1){
     if(e1 === 'booking_slots'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(booking_slots?.find((r)=>r?.value === ele))
      })
      setdata({...data,booking_slots:arr})
      seterror({...error,booking_slots:''})
    }
    if(e1 === 'batches_slots'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(batches_slots?.find((r)=>r?.value === ele))
      })
      setdata({...data,batches_slots:arr})
      seterror({...error,batches_slots:''})
    }
    if(e1 === 'type'){
      setdata({...data,type:teacherTypeArr?.find((t)=>t?.value === e)})
      seterror({...error,type:''})
    }
    if(e1 === 'class'){
      setdata({...data,class:filter_standard?.find((t)=>t?.value === e)})
      seterror({...error,class:''})
    }
    if(e1 === 'mode'){
      setdata({...data,mode:modesArr?.find((t)=>t?.value === e)})
      seterror({...error,mode:''})
    }
  }

  
  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen md:min-h-screen md:overflow-hidden'>
        <div className='md:flex'> 
         <SettingsMenu />
          <div className='px-5 md:w-full'>

          
        <div className='md:flex md:w-full md:min-h-screen md:max-h-screen md:overflow-y-scroll mb-10'>
        <div className='w-full md:border-r md:w-64 md:pr-5 md:pt-5'>
        <GoBack />  

        <h6 className='font-[700] mb-1'>Create/Edit Teacher</h6>
          <h6 className='text-[11px] p-2  mb-2 bg-slate-100'>Use the below form to create or update a teacher</h6>
        


        <TextInput 
         label={'Name'}  
         variant="standard"
         name="name"
         type="text"
         error={error.name}
         value={data.name}
         handlechange={handlechange}
         placeholder="Enter your Department name"
         />

        <TextInput 
         label={'Employee Id'}  
         variant="standard"
         name="employee_id"
         type="text"
         error={error.employee_id}
         value={data.employee_id}
         handlechange={handlechange}
         placeholder="Enter your Employee Id"
         />


        <div className="w-full mr-1"> 
        <TextInput 
         label={'Phone'}  
         variant="standard"
         name="phone"
         type="text"
         error={error.phone}
         value={data.phone}
         handlechange={handlechange}
         placeholder="Enter your Phone"
         />
        </div> 

        <div className="w-full mr-1"> 
        <TextInput 
         label={'Email'}  
         variant="standard"
         name="email"
         type="text"
         error={error.email}
         value={data.email}
         handlechange={handlechange}
         placeholder="Enter your email"
         />
        </div> 

         <div className="w-full mr-1"> 
        <TextInput 
         label={'Sort'}  
         variant="standard"
         name="sort"
         type="number"
         error={error.sort}
         value={data.sort}
         handlechange={handlechange}
         placeholder="Enter your sort"
         />
        </div> 

       <div className="w-full mr-1"> 
        <TextInput 
         label={'Designation'}  
         variant="standard"
         name="designation"
         type="text"
         error={error.designation}
         value={data.designation}
         handlechange={handlechange}
         placeholder="Enter your designation"
         />
        </div> 

         <div className="w-full mr-1"> 
        <TextAreaInput1 
         label={'Expertise'}  
         variant="standard"
         name="expertise"
         type="text"
         error={error.expertise}
         value={data.expertise}
         handlechange={handlechange}
         placeholder=""
         />
        </div>   
        

        <div className="w-full mt-2">
          <div className='flex justify-between items-center'>
          <h6 className='text-[12px] mb-1'>Teacher Type</h6>
          </div>

                   <Select
                     value={data.type} 
                     error={error.type}
                     bordered={false}
                     placeholder="" 
                     onChange={(e)=>handleSelect(e,'type')} 
                     options={teacherTypeArr} 
                     className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
          
                     />
                   {error.batches_slots !== '' && error.batches_slots !== undefined &&
                   <div className='flex items-center mt-1'>
                   <BiErrorCircle className='text-red-500' size={14} />
                   <span className='text-[10px] text-red-500 ml-1'>{error.batches_slots}</span>
                   </div>}


        </div>

        <div className="w-full mt-2">
          <div className='flex justify-between items-center'>
          <h6 className='text-[12px] mb-1'>Standard</h6>
          </div>

          <Select
            value={data.class} 
            error={error.class}
            bordered={false}
            placeholder="" 
            onChange={(e)=>handleSelect(e,'class')} 
            options={filter_standard} 
            className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'

            />
          {error.class !== '' && error.class !== undefined &&
          <div className='flex items-center mt-1'>
          <BiErrorCircle className='text-red-500' size={14} />
          <span className='text-[10px] text-red-500 ml-1'>{error.class}</span>
          </div>}


        </div>


      
        {data.type?.value === 'Counsellor' && 
        <div className="w-full mt-2">
          <div className='flex justify-between items-center'>
          <h6 className='text-[12px] mb-1'>Booking Slots</h6>
          {/* <CiSquarePlus onClick={()=>addBookingSlots()} /> */}
          </div>

                   <Select
                     value={data.booking_slots} 
                     error={error.booking_slots}
                     bordered={false}
                     placeholder="" 
                     mode="multiple"
                     onChange={(e)=>handleSelect(e,'booking_slots')} 
                     options={booking_slots} 
                     className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
          
                     />
                   {error.booking_slots !== '' && error.booking_slots !== undefined &&
                   <div className='flex items-center mt-1'>
                   <BiErrorCircle className='text-red-500' size={14} />
                   <span className='text-[10px] text-red-500 ml-1'>{error.booking_slots}</span>
                   </div>}

          {/* {data?.booking_slots?.map((w,i)=>(
            <div className="w-full p-2 border mt-2">

             <div className='flex  mb-1 items-center justify-between'> 
             <h6 className='text-[12px] font-[700]'>Slot {i+1}</h6> 
             <IoCloseCircleOutline onClick={()=>removeWorkHourSlot(i)} />
             </div>
          
          <label className="text-[11px] block mb-1">Start Time</label>
          <input
            type="time"
            className="border p-1.5 w-full text-[11px] border-gray-300"
            value={data?.booking_slots[i]?.start_time || ''}
            onChange={(e) => {
              const updatedSlots = [...data.booking_slots];
              updatedSlots[i].start_time = e.target.value;

              setdata({
                ...data,
                booking_slots: updatedSlots
              });

              const updatedErrors = [...error.booking_slots];
              updatedErrors[i].start_time = "";
              seterror({
                ...error,
                booking_slots: updatedErrors
              });
            }}
          />
          {error?.booking_slots[i]?.start_time && (
            <h6 className="text-red-600 text-[10px]">{error?.booking_slots[i]?.start_time}</h6>
          )}

          <label className="text-[11px] block mt-2 mb-1">End Time</label>
          <input
            type="time"
            className="border p-1.5 w-full text-[11px] border-gray-300"
            value={data?.booking_slots[i]?.end_time || ''}
            onChange={(e) => {
              const updatedSlots = [...data.booking_slots];
              updatedSlots[i].end_time = e.target.value;

              setdata({
                ...data,
                booking_slots: updatedSlots
              });

              const updatedErrors = [...error.booking_slots];
              updatedErrors[i].end_time = "";
              seterror({
                ...error,
                booking_slots: updatedErrors
              });
            }}
          />
          {error?.booking_slots[i]?.end_time && (
            <h6 className="text-red-600 text-[10px]">{error?.booking_slots[i]?.end_time}</h6>
          )}
            </div>
          ))} */}


        </div>}

        {data.type?.value === 'Batch' && 
        <div className="w-full mt-2">
          <div className='flex justify-between items-center'>
          <h6 className='text-[12px] mb-1'>Batches Slots</h6>
          </div>

                   <Select
                     value={data.batches_slots} 
                     error={error.batches_slots}
                     bordered={false}
                     placeholder="" 
                     mode="multiple"
                     onChange={(e)=>handleSelect(e,'batches_slots')} 
                     options={batches_slots} 
                     className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
          
                     />
                   {error.batches_slots !== '' && error.batches_slots !== undefined &&
                   <div className='flex items-center mt-1'>
                   <BiErrorCircle className='text-red-500' size={14} />
                   <span className='text-[10px] text-red-500 ml-1'>{error.batches_slots}</span>
                   </div>}


        </div>}

         <div>
             <h6 className='text-[11px] mb-1 mt-2'>Mode </h6>
                <Select
                  value={data.mode} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'mode')} 
                  options={modesArr} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            {error.mode !== '' && error.mode !== undefined &&
            <div className='flex items-center mt-1'>
            <BiErrorCircle className='text-red-500' size={14} />
            <span className='text-[10px] text-red-500 ml-1'>{error.mode}</span>
            </div>}

         <Uploader error={error?.profile_photo} name="profile_photo" required={false} label={'Profile Photo'} image={data?.profile_photo}  setimagefunc={(e)=>{UploadFile(e,'profile_photo');seterror({...error,profile_photo:''})}}  removeimageuploadfunc = {()=>{setdata({...data,profile_photo:''});seterror({...error,profile_photo:''})}} />


        

          <div  className='flex mt-2 items-center'>
          <div className='flex items-center mt-0 mr-2'>
          {data?.is_verified ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,is_verified:!data.is_verified})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,is_verified:!data.is_verified})}  /> }
          <h6 className="text-[10px] font-[600] ml-1">Is Verified</h6> 
          </div>  
          <div className='flex items-center mt-0 mr-2'>
          {data?.is_active ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,is_active:!data.is_active})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,is_active:!data.is_active})}  /> }
          <h6 className="text-[10px] font-[600] ml-1">Is Active</h6> 
          </div>  


         
          </div>   

          <div className='flex items-center'>
        
          <div className='flex items-center mt-0 mr-2'>
          {data?.app_access ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,app_access:!data.app_access})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,app_access:!data.app_access})}  /> }
          <h6 className="text-[10px] font-[600] ml-1">App Access</h6>
          </div>

          <div className='flex items-center mt-0 mr-2'>
          {data?.show_in_feedback ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,show_in_feedback:!data.show_in_feedback})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,show_in_feedback:!data.show_in_feedback})}  /> }
          <h6 className="text-[10px] font-[600] ml-1">Show in Parent Reviews</h6>
          </div>

          </div>



         <div className='flex mt-4 pb-5'>
            <ButtonOutlinedAutoWidth btnName={'Back'} onClick={()=>{navigate(-1)}} />
            <div className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Save'} onClick={submitdata} />
            </div>
         </div>
        </div>
       
         </div>
         </div>
         </div>




    </div>
  )
}

export default TeacherCE